import React, { useState } from 'react';

import { useFetch } from 'hooks';

import { useJobNotificationContext } from 'containers/common/JobNotificationProvider';

import { Badge, Mui } from 'components';
import { Dialogs, DisplayStatus } from 'components/common';
import { Drawer, ProgressWrapper } from 'components/layouts';

import * as api from './api';

export function CommonJobNotification() {
  const { count: jobsCount = 0 } = useJobNotificationContext() || {};

  const [open, setOpen] = useState(false);
  const [selectedJob, setSelectedJob] = useState('');
  const [query, setQuery] = useState({ page: 1, page_size: 10, ordering: '-date_created' });
  const { page, page_size: pageSize } = query;

  const { data: listData, isValidating } = useFetch([open && api.endpoints.list(), query]);
  const { results = [], count = 0 } = listData || {};

  const { data: selectedJobData } = useFetch([
    !!selectedJob && api.endpoints.retrieve(selectedJob),
  ]);
  const selectedErrors = selectedJobData?.outputJson?.errors || [];

  return (
    <>
      <Mui.IconButton onClick={() => setOpen(true)}>
        <Badge badgeContent={jobsCount} color="primary" overlap="rectangular">
          <Mui.Icon color={jobsCount > 0 ? 'primary' : 'inherit'}>update</Mui.Icon>
        </Badge>
      </Mui.IconButton>
      <Drawer
        description="Estes são os trabalhos que foram ou estão sendo processados por nossos servidores referentes a importações, exportações ou qualquer tipo de atividade que requeira algum processamento prolongado."
        onClose={() => setOpen(false)}
        open={open}
        title="Processamento de atividades">
        <Mui.Container>
          <ProgressWrapper loading={isValidating}>
            <Mui.Paper variant="outlined">
              <Mui.List dense>
                {results.length === 0 && (
                  <Mui.ListItem>
                    <Mui.ListItemText primary="Nenhum trabalho disponível" />
                  </Mui.ListItem>
                )}
                {results.map((job, index, array) => (
                  <Mui.ListItem key={job.uid} divider={index < array.length - 1}>
                    <Mui.ListItemAvatar>
                      <DisplayStatus.Job
                        onlyIcon
                        status={job.status}
                        statusDisplay={job.statusDisplay}
                        variant="filled"
                      />
                    </Mui.ListItemAvatar>
                    <Mui.ListItemText
                      primary={job.typeDisplay}
                      secondary={
                        <>
                          {job.taskDisplay && job.actionDisplay && (
                            <Mui.Typography variant="body2">
                              {job.taskDisplay} - {job.actionDisplay}
                            </Mui.Typography>
                          )}
                          <Mui.Typography variant="body2">
                            <em>{job.dateCompleted}</em>
                          </Mui.Typography>
                        </>
                      }
                    />
                    <Mui.ListItemSecondaryAction>
                      {job.status === 'errored' && (
                        <Mui.Tooltip title="Ver mais">
                          <Mui.IconButton onClick={() => setSelectedJob(job.uid)}>
                            <Mui.Icon>visibility</Mui.Icon>
                          </Mui.IconButton>
                        </Mui.Tooltip>
                      )}
                      {job.inputFile && (
                        <Mui.Tooltip title="Arquivo de entrada">
                          <Mui.IconButton component="a" href={job.inputFile} target="_blank">
                            <Mui.Icon>file_copy</Mui.Icon>
                          </Mui.IconButton>
                        </Mui.Tooltip>
                      )}
                      {job.outputFile && (
                        <Mui.Tooltip title="Arquivo de saída">
                          <Mui.IconButton component="a" href={job.outputFile} target="_blank">
                            <Mui.Icon>cloud_download</Mui.Icon>
                          </Mui.IconButton>
                        </Mui.Tooltip>
                      )}
                    </Mui.ListItemSecondaryAction>
                  </Mui.ListItem>
                ))}
              </Mui.List>
            </Mui.Paper>
          </ProgressWrapper>
          {count > 0 && (
            <Mui.TablePagination
              component="div"
              count={count}
              onPageChange={(event, newPage) =>
                setQuery(prevQuery => ({ ...prevQuery, page: newPage + 1 }))
              }
              onRowsPerPageChange={event =>
                setQuery(prevQuery => ({ ...prevQuery, page_size: event.target.value, page: 1 }))
              }
              page={page - 1}
              rowsPerPage={pageSize}
              rowsPerPageOptions={[10, 25, 50]}
            />
          )}
        </Mui.Container>
      </Drawer>
      <Dialogs.Alert
        onClose={() => setSelectedJob('')}
        open={!!selectedJob}
        severity="warning"
        title={selectedJobData?.typeDisplay}>
        <Mui.Box display="flex">
          <Mui.Typography variant="body1">
            {selectedErrors.length > 0 && (
              <strong>{selectedErrors.length === 1 ? 'Erro: ' : 'Erros: '}</strong>
            )}
            {selectedErrors.join(', ')}
          </Mui.Typography>
        </Mui.Box>
      </Dialogs.Alert>
    </>
  );
}

CommonJobNotification.propTypes = {};

export default CommonJobNotification;
